import Button from 'components/Button';
import DataTable from 'components/DataTable';
import ListActionsWrapper from 'components/ListActionsWrapper';
import ListWrapper from 'components/ListWrapper';
import SearchInput from 'components/SearchInput';
import PageHeader from 'components/PageHeader';
import Typography from 'components/Typography';
import Filter from 'components/Filter';

import useEmployees from './useEmployees';

import styles from '../Settings.module.scss';
import {DataItem, DataTableSchemaItem} from 'types';
import {useCallback} from 'react';
import {useHistory} from 'react-router-dom';
import Pagination from 'components/Pagination';

const SCHEMA: DataTableSchemaItem[] = [
  {
    dataKey: 'name',
    header: 'Employee name',
    sortable: true,
  },
  {
    dataKey: 'phone',
    header: 'Phone number',
    sortable: true,
  },
  {
    dataKey: 'role',
    header: 'Employee status',
    sortable: true,
  },
  {dataKey: 'view', header: ''},
];

function Employees() {
  const {
    count,
    pageSize,
    setPageSize,
    currentPage,
    setCurrentPage,
    data,
    isLoading,
    filterOptions,
    filterValue,
    sortBy,
    sortOrder,
    onChangeFilter,
    onSort,
    keyWord,
    setKeyWord,
    canWrite,
  } = useEmployees();

  const history = useHistory();

  const handleNavigateEmployee = useCallback(
    (row: DataItem) => {
      history.push(`/settings/employees/${row.id}`);
    },
    [history]
  );

  return (
    <div className={styles.main_container}>
      <PageHeader>
        <Typography variant="h2">Employees</Typography>
        {canWrite && (
          <Button to="/settings/employees/new" component="a" color="green">
            New Employee
          </Button>
        )}
      </PageHeader>

      <ListWrapper>
        <ListActionsWrapper className={styles.list_header}>
          <SearchInput
            value={keyWord}
            onChange={(val) => {
              setKeyWord(val.target.value);
              setCurrentPage(1);
              sessionStorage.setItem(`search_employe`, val.target.value);
            }}
            size="sm"
          />
          <Filter
            size="sm"
            options={filterOptions}
            value={filterValue}
            onChange={onChangeFilter}
          />
        </ListActionsWrapper>
        <DataTable
          sortBy={sortBy}
          sortOrder={sortOrder}
          onSort={onSort}
          selectable={false}
          data={data}
          schema={SCHEMA}
          loading={isLoading}
          onClick={handleNavigateEmployee}
        />
      </ListWrapper>
      <Pagination
        count={count}
        pageSize={pageSize}
        setPageSize={setPageSize}
        page={currentPage}
        total={Math.round(count / pageSize)}
        setCurrentPage={setCurrentPage}
      />
    </div>
  );
}

export default Employees;
